import { TaskStatus } from "./task-status"

export class ScheduleComment {
    id: string
    text: string
    timestamp: string
    archived: boolean
    userId: string
}

export abstract class Task {

    _id: string
    assignedUserId?: string
    title?: string
    type: 'scout' | 'path test' | 'drive test'
    pathId?: string
    stage?: string
    routeId?: string
    buildingId?: string
    cycle?: number
    groupingfield?:string
    schedule: {
        scheduleRequestedDate?: string,
        scheduledDate?: string,
        scheduleNotes?: string,
        scheduleComments?: ScheduleComment[]
    }
    assignments: {
        scheduleUserId?: string,
        testUserId?: string
    }
    _rev?: string
    updatedAt?: string
    updatedUserId?: string

    //state: TaskState

    status?: {
        scheduleRequested?: TaskStatus,
        scheduled?: TaskStatus,
        inProgress?: TaskStatus,
        complete?: TaskStatus,
        approved?: TaskStatus,
        archived?: TaskStatus
    }

    static isDriveTestTask(t:Task) {
        return t.type == "drive test"
    }

    static isPathTestTask(t:Task) {
        return t.type == "path test"
    }

    static isScoutTask(t:Task) {
        return t.type == "scout"
    }


}
